// src/components/layout/AIBackground.tsx
import React from 'react';

export const AIBackground: React.FC = () => {
  return (
    <div className="fixed inset-0 bg-gradient-to-br from-slate-50 via-white to-blue-50/40 pointer-events-none">
      {/* Animated gradient mesh - AMPLIFIED */}
      <div className="absolute inset-0">
        <div className="absolute top-20 left-10 w-[450px] h-[450px] bg-gradient-to-br from-blue-400/80 to-transparent rounded-full blur-3xl animate-pulse" style={{animationDuration: '2s'}}></div>
        <div className="absolute top-40 right-20 w-[420px] h-[420px] bg-gradient-to-bl from-purple-400/75 to-transparent rounded-full blur-3xl animate-pulse" style={{animationDuration: '2.5s', animationDelay: '0.5s'}}></div>
        <div className="absolute bottom-32 left-1/4 w-[400px] h-[400px] bg-gradient-to-tr from-cyan-400/80 to-transparent rounded-full blur-3xl animate-pulse" style={{animationDuration: '3s', animationDelay: '1s'}}></div>
        <div className="absolute bottom-20 right-1/3 w-[380px] h-[380px] bg-gradient-to-tl from-blue-500/70 to-transparent rounded-full blur-3xl animate-pulse" style={{animationDuration: '2.8s', animationDelay: '0.3s'}}></div>
      </div>

      {/* Neural network inspired pattern - AMPLIFIED */}
      <svg className="absolute inset-0 w-full h-full opacity-[0.25]" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="lineGradient1" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="rgb(59, 130, 246)" stopOpacity="0.3"/>
            <stop offset="50%" stopColor="rgb(139, 92, 246)" stopOpacity="0.8"/>
            <stop offset="100%" stopColor="rgb(6, 182, 212)" stopOpacity="0.3"/>
          </linearGradient>
          <linearGradient id="lineGradient2" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="rgb(139, 92, 246)" stopOpacity="0.3"/>
            <stop offset="50%" stopColor="rgb(59, 130, 246)" stopOpacity="0.8"/>
            <stop offset="100%" stopColor="rgb(139, 92, 246)" stopOpacity="0.3"/>
          </linearGradient>
          <radialGradient id="nodeGradient">
            <stop offset="0%" stopColor="rgb(59, 130, 246)" stopOpacity="1"/>
            <stop offset="70%" stopColor="rgb(139, 92, 246)" stopOpacity="0.6"/>
            <stop offset="100%" stopColor="rgb(6, 182, 212)" stopOpacity="0.2"/>
          </radialGradient>
          
          <pattern id="neural" x="0" y="0" width="200" height="200" patternUnits="userSpaceOnUse">
            {/* Connection lines with gradients */}
            <line x1="40" y1="40" x2="100" y2="80" stroke="url(#lineGradient1)" strokeWidth="2" strokeDasharray="4,4"/>
            <line x1="100" y1="80" x2="160" y2="40" stroke="url(#lineGradient1)" strokeWidth="2" strokeDasharray="4,4"/>
            <line x1="40" y1="160" x2="100" y2="120" stroke="url(#lineGradient2)" strokeWidth="2" strokeDasharray="4,4"/>
            <line x1="100" y1="120" x2="160" y2="160" stroke="url(#lineGradient2)" strokeWidth="2" strokeDasharray="4,4"/>
            <line x1="40" y1="40" x2="40" y2="160" stroke="url(#lineGradient2)" strokeWidth="1.5" opacity="0.4"/>
            <line x1="100" y1="80" x2="100" y2="120" stroke="url(#lineGradient2)" strokeWidth="1.5" opacity="0.5"/>
            <line x1="160" y1="40" x2="160" y2="160" stroke="url(#lineGradient2)" strokeWidth="1.5" opacity="0.4"/>
            
            {/* Neural nodes with gradient fills */}
            <circle cx="40" cy="40" r="5" fill="url(#nodeGradient)" opacity="0.7"/>
            <circle cx="100" cy="80" r="6" fill="url(#nodeGradient)" opacity="0.9"/>
            <circle cx="160" cy="40" r="5" fill="url(#nodeGradient)" opacity="0.7"/>
            <circle cx="40" cy="160" r="5" fill="url(#nodeGradient)" opacity="0.7"/>
            <circle cx="100" cy="120" r="6" fill="url(#nodeGradient)" opacity="0.9"/>
            <circle cx="160" cy="160" r="5" fill="url(#nodeGradient)" opacity="0.7"/>
            
            {/* Accent dots with glow effect */}
            <circle cx="70" cy="60" r="5" fill="rgb(6, 182, 212)">
              <animate attributeName="opacity" values="0.3;1;0.3" dur="1.5s" repeatCount="indefinite"/>
              <animate attributeName="r" values="3;6;3" dur="1.5s" repeatCount="indefinite"/>
            </circle>
            <circle cx="130" cy="100" r="5" fill="rgb(139, 92, 246)">
              <animate attributeName="opacity" values="1;0.3;1" dur="1.5s" repeatCount="indefinite"/>
              <animate attributeName="r" values="6;3;6" dur="1.5s" repeatCount="indefinite"/>
            </circle>
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#neural)"/>
      </svg>
      
      {/* Corner gradient accents - AMPLIFIED */}
      <div className="absolute -top-40 -left-40 w-[600px] h-[600px] bg-gradient-to-br from-blue-500/15 via-cyan-500/10 to-transparent rounded-full blur-3xl"></div>
      <div className="absolute -bottom-40 -right-40 w-[600px] h-[600px] bg-gradient-to-tl from-purple-500/15 via-blue-500/10 to-transparent rounded-full blur-3xl"></div>
    </div>
  );
};
